import { AlertsProvider } from '@dhis2/app-service-alerts';
import { ConfigProvider } from '@dhis2/app-service-config';
import { DataProvider } from '@dhis2/app-service-data';
import { OfflineProvider } from '@dhis2/app-service-offline';
import React from 'react';
export const Provider = (_ref) => {
  let {
    config,
    children,
    offlineInterface,
    plugin,
    parentAlertsAdd,
    showAlertsInPlugin
  } = _ref;
  return /*#__PURE__*/React.createElement(ConfigProvider, {
    config: config
  }, /*#__PURE__*/React.createElement(AlertsProvider, {
    plugin: plugin,
    parentAlertsAdd: parentAlertsAdd,
    showAlertsInPlugin: showAlertsInPlugin
  }, /*#__PURE__*/React.createElement(DataProvider, null, /*#__PURE__*/React.createElement(OfflineProvider, {
    offlineInterface: offlineInterface
  }, children))));
};
Provider.displayName = 'DHIS2RuntimeProvider';